import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import help from "../assets/js/help";
import {Dialog} from "vant";
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/about",
    name: "About",
    component: () => import("../views/About.vue")
  },
  {
    path: "/detail/:id",
    name: "Detail",
    component: () => import("../views/detail/detail-wrapper"),
    children: [
      {
        path: "article",
        component: () => import("../views/detail/articles.vue"),
        meta: {
          title: "图文详情",
        },
      },
      {
        path: "videoLast",
        component: () => import("../views/detail/videos-last.vue"),
        meta: {
          title: "视频详情",
        },
      },
      {
        path: "video",
        component: () => import("../views/detail/videos.vue"),
        meta: {
          title: "视频详情",
        },
      }
    ]
  },
  {
    path: "/list/:id",
    name: "List",
    component: () => import("../views/list/list-wrapper.vue"),
    children: [
      {
        path: "circle",
        component: () => import("../views/list/circle.vue")
      },
      {
        path: "subject",
        component: () => import("../views/list/subject.vue")
      }
    ]
  },
  {
    path: "/user/:id",
    name: "User",
    component: () => import("../views/list/user.vue")
  }
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});
let isFirst = true;
router.beforeEach(async (to, from, next) => {
    const title = to.meta && to.meta.title;
    if (title) {
        document.title = title;
    }
    if (window._hmt) {
        if (to.path) {
            window._hmt.push(["_trackPageview", to.href]);
        }
    }
    if (window._czc) {
        if (to.path) {
            let contentUrl = to.href;
            let refererUrl = "/";
            window._czc.push(["_trackPageview", contentUrl, refererUrl]);
        }
    }
    if (isFirst) {
        isFirst = false;
        next();
        return;
    }
    if (to.href) {
        help.confirmApp(to.href, next);
    } else {
        next();
    }
});
export default router;
